const alertSelector = state => state.alert;
export default alertSelector;
